import { LocaleEnum } from '@systemeio/ui-frontend'
import PublicHeaderBlogIcon from '../icons/public-header-blog-icon'
import PublicHeaderFeaturesIcon from '../icons/public-header-features-icon'
import PublicHeaderPricingIcon from '../icons/public-header-pricing-icon'
import PublicHeaderQuestionMarkIcon from '../icons/public-header-question-mark-icon'
import PublicHeaderTestimonialsIcon from '../icons/public-header-testimonials-icon'

interface MenuItemsInterface {
  title: string
  icon: JSX.Element
  href: string
  excludeLocales?: LocaleEnum[]
}

export const topMenuItems: MenuItemsInterface[] = [
  {
    title: 'public.public_header.why_systeme',
    icon: <PublicHeaderQuestionMarkIcon />,
    href: '/why-systeme',
  },
  { title: 'public.public_header.features', icon: <PublicHeaderFeaturesIcon />, href: '/features' },
  { title: 'public.public_header.pricing', icon: <PublicHeaderPricingIcon />, href: '/pricing' },
  { title: 'public.public_header.blog', icon: <PublicHeaderBlogIcon />, href: '/blog' },
  {
    title: 'public.public_header.testimonials',
    icon: <PublicHeaderTestimonialsIcon />,
    href: '/testimonials',
    excludeLocales: [LocaleEnum.DEUTSCH, LocaleEnum.RUSSIAN, LocaleEnum.JAPANESE],
  },
]
